import { OptionModel, OptionType } from '@akin-home/options';

export const MEAL_TYPE_OPTIONS: OptionModel[] = [
  {
    id: 'Breakfast',
    label: 'Breakfast',
    type: OptionType.MEAL_TYPE,
    code: 'meal_type_breakfast',
  },
  {
    id: 'Lunch',
    label: 'Lunch',
    type: OptionType.MEAL_TYPE,
    code: 'meal_type_lunch',
  },
  {
    id: 'Dinner',
    label: 'Dinner',
    type: OptionType.MEAL_TYPE,
    code: 'meal_type_dinner',
  },
  {
    id: 'Snack',
    label: 'Snack',
    type: OptionType.MEAL_TYPE,
    code: 'meal_type_snack',
  },
];
